module.exports = __webpack_public_path__ + "img/icon-server-mhs-1.724b5da5.svg";